function ChartCard({ title, children, action }) {
  return (
    <div style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 'var(--radius)', padding: '14px', boxShadow: 'var(--shadow)',
      flex: '1 1 300px', minWidth: '260px', maxWidth: '100%',
      display: 'flex', flexDirection: 'column',
      height: '280px', minHeight: '280px', maxHeight: '280px',
      overflow: 'hidden'
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        marginBottom: '8px', flexShrink: 0
      }}>
        <h3 style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: 'var(--text-primary)' }}>
          {title}
        </h3>
        {action}
      </div>
      <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        {children}
      </div>
    </div>
  );
}

export default ChartCard;

